/**
 * Frontend uses kebab-case service IDs (e.g. "itr-filing"); backend expects
 * snake_case (e.g. "itr_filing"). These helpers preserve a single source of
 * truth instead of duplicating the conversion in three apps.
 */
export function kebabToSnake(input: string): string {
  return input.replace(/-/g, '_');
}

export function snakeToKebab(input: string): string {
  return input.replace(/_/g, '-');
}

export function snakeToCamel(input: string): string {
  return input.replace(/_([a-z])/g, (_, c: string) => c.toUpperCase());
}

export function camelToSnake(input: string): string {
  return input.replace(/([A-Z])/g, '_$1').toLowerCase();
}
